import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api, resolveAssetUrl } from "../../lib/api";
import { ArrowRight, Clock, Layers, ShoppingBag } from "lucide-react";

const DEFAULT_COVER =
  "https://customer-assets.emergentagent.com/job_athletic-edge-19/artifacts/z57p91jo_IMG_2623%202.PNG";

export default function ClientPrograms() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/me/programs");
        if (alive) setPrograms(data);
      } catch {
        // ignore
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <AppShell>
      <div className="p-5 sm:p-8 max-w-5xl" data-testid="client-programs">
        <div className="qv-overline">MI BIBLIOTECA</div>
        <h1 className="qv-display text-white text-4xl sm:text-5xl mt-2">Mis programas</h1>
        <p className="mt-3 text-neutral-400 text-sm">Todo lo que has comprado. Acceso de por vida.</p>

        <div className="mt-10">
          {loading && <div className="text-neutral-500 text-sm">Cargando...</div>}

          {!loading && programs.length === 0 && (
            <div className="border border-white/10 bg-[#0a0a0a] p-10 text-center" data-testid="programs-empty">
              <ShoppingBag size={28} color="var(--qv-red)" className="mx-auto" />
              <div className="qv-overline mt-4">TODAVÍA NADA POR AQUÍ</div>
              <h2 className="qv-display text-white text-2xl mt-3">No has comprado programas aún.</h2>
              <p className="mt-3 text-neutral-400 text-sm max-w-md mx-auto">
                Explora los programas disponibles y empieza a entrenar hoy mismo.
              </p>
              <a href="/programas" className="qv-btn-primary mt-6 inline-flex">
                VER PROGRAMAS <ArrowRight size={16} />
              </a>
            </div>
          )}

          {!loading && programs.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="my-programs-grid">
              {programs.map((p) => (
                <Link
                  key={p.id}
                  to={`/app/programas/${p.id}`}
                  className="qv-testi-card group flex flex-col overflow-hidden"
                  data-testid={`my-program-card-${p.slug}`}
                >
                  <div className="qv-testi-photo">
                    <img src={resolveAssetUrl(p.cover_image) || DEFAULT_COVER} alt={p.title} loading="lazy" />
                    <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black to-transparent pointer-events-none" />
                    <div className="absolute top-3 left-3 bg-black/80 backdrop-blur-md px-3 py-1 border border-white/10 text-[10px] tracking-[0.2em] uppercase text-white font-bold" style={{ borderColor: "rgba(37,211,102,0.5)" }}>
                      Comprado
                    </div>
                  </div>
                  <div className="p-6 flex flex-col gap-4 flex-1">
                    <h3 className="qv-display text-white text-2xl leading-tight group-hover:text-[color:var(--qv-red)] transition-colors">
                      {p.title}
                    </h3>
                    <div className="flex flex-wrap gap-3 text-[11px] text-neutral-300">
                      <span className="inline-flex items-center gap-1.5"><Clock size={13} color="var(--qv-red)" /> {p.duration_weeks} sem</span>
                      <span className="inline-flex items-center gap-1.5"><Layers size={13} color="var(--qv-red)" /> {p.total_sessions} sesiones</span>
                    </div>
                    <div className="mt-auto pt-4 border-t border-white/10 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-bold text-white">
                      Empezar <ArrowRight size={14} />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </AppShell>
  );
}
